import {  Injectable } from '@angular/core';
import { BehaviorSubject, Subject, distinctUntilChanged } from 'rxjs';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { valorlatenteinterface } from 'src/app/interface/ValorLatenteInterface';
import { rendimientoanualinterface } from 'src/app/interface/RendimientoAnualInterface';
import { tablainterface } from 'src/app/interface/TablaInterface';
import { valorliquidativointerface } from '../interface/ValorLiquidativoInterface';
import { OptimalWallet } from '../interface/OptimalWallet';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root',
})

export class GestionService {
    public idnectumsArray= new BehaviorSubject<any>([]);; // Array global para almacenar idnectums

    updategestorIdnectumsArray(gestorIdnectumsArray: any) {
        this.idnectumsArray.next(gestorIdnectumsArray);
    }
    constructor(private _cookieService: CookieService) { }
    private activadoAutoSubject = new BehaviorSubject<boolean>(false);
    activadoAuto$ = this.activadoAutoSubject.asObservable();
    private existeMargenSubject = new BehaviorSubject<boolean>(true);
    existeMargen$ = this.existeMargenSubject.asObservable();
  
    private existeRiesgoSubject = new BehaviorSubject<boolean>(true);
    existeRiesgo$ = this.existeRiesgoSubject.asObservable();
  
    updateExisteMargen(value: boolean) {
      this.existeMargenSubject.next(value);
    }
  
    updateExisteRiesgo(value: boolean) {
      this.existeRiesgoSubject.next(value);
    }
    updateActivadoAuto(idcartera: number) {
      const isActivated = this._cookieService.check('auto' + idcartera);
      this.activadoAutoSubject.next(isActivated);
    }

    /* Behavior Subject */
    private gestOperaciones = new BehaviorSubject<operationinterface[]>([]);
    private gestValLatente = new BehaviorSubject<valorlatenteinterface[]>([]);
    private gestValLiq = new BehaviorSubject<valorliquidativointerface[]>([]);
    private gestValPos = new BehaviorSubject<operationinterface[]>([]);
    private gestValVentas = new BehaviorSubject<operationinterface[]>([]);
    private gestRentabilidad = new BehaviorSubject<tablainterface[]>([]);
    private gestRendAnual = new BehaviorSubject<rendimientoanualinterface[]>([]);
    private gestRiesgo = new BehaviorSubject<tablainterface[]>([]);
    private gestidcarteras = new BehaviorSubject<number[]>([0,0,0,0,0]);
    private gestFechaFiltro = new BehaviorSubject<string>('');
    private gestOptimaWallet = new BehaviorSubject<OptimalWallet[]>([]);
    private getcarteraTemporal = new BehaviorSubject<any>('');
    private companiaMercado = new BehaviorSubject<any>([]);
    public idMercado = new BehaviorSubject<any>('');
    executeGrap = new BehaviorSubject<boolean>(false);
    private actualizarCartera = new BehaviorSubject<boolean>(false);
    isProc = new BehaviorSubject<boolean>(false);
    isACtual = new BehaviorSubject<boolean>(false);

    /* Observables */
    valGestOp$ = this.gestOperaciones.asObservable();
    valGestLatente$ = this.gestValLatente.asObservable();
    valGestValLiq$ = this.gestValLiq.asObservable();
    valGestValPos$ = this.gestValPos.asObservable();
    valGestVentas$ = this.gestValVentas.asObservable();
    valGestRentabilidad$= this.gestRentabilidad.asObservable();
    valGestRendAnual$ = this.gestRendAnual.asObservable();
    valGestRiesgo$ = this.gestRiesgo.asObservable();
    valGestIdeCarteras$ = this.gestidcarteras.asObservable();
    valGestFechaFiltro$ = this.gestFechaFiltro.asObservable();
    valgestOptimaWallet$ =this.gestOptimaWallet.asObservable();
    valgestExecuteGrap$ = this.executeGrap.asObservable();
    valgestgetcarteraTemporal$ = this.getcarteraTemporal.asObservable();
    valgestcompaniaMercado$ = this.companiaMercado.asObservable();
    valgestidMercado$ = this.idMercado.asObservable();
    idnectumsArray$ = this.idnectumsArray.asObservable();
    valactualizarCartera$ = this.actualizarCartera.asObservable().pipe(
        distinctUntilChanged()
    );

    valIsProc$= this.isProc.asObservable();
    valisACtual$ = this.isACtual.asObservable();
//  auto: boolean=false;

    updateIsProc(value: boolean): void {
        this.isProc.next(value);
    }

    getOptimaWallet(){
        return this.gestOptimaWallet.value;
    }
  
    updateIsACtual(value: boolean): void {
        this.isACtual.next(value);
    }

    updateactualizarCartera(data: any){
        if (this.actualizarCartera.getValue() !== data) {
            this.actualizarCartera.next(data); // línea 66
        }
    }

    updateGestExecuteGrap(data: boolean){
        this.executeGrap.next(data);
    }

    updategestidMercado(data: any){
        this.idMercado.next(data);
    }

    updatecompaniaMercado(data: any){
        this.companiaMercado.next(data);
    }

    updategetcarteraTemporal(data: any){
        this.getcarteraTemporal.next(data);
    }

    updateGestOpe(newOpe: any){
        this.gestOperaciones.next(newOpe);
    }

    updategestValLatente(data: any){
        this.gestValLatente.next(data);
    }

    updategestValLiq(data: any){
        this.gestValLiq.next(data);
    }
    updategestValPos(data: any){
        this.gestValPos.next(data);
    }
    updategestValVentas(data: any){
        this.gestValVentas.next(data);
    }
    updategestRentabilidad(data: any){
        this.gestRentabilidad.next(data);
    }
    updategestRendAnual(data: any){
        this.gestRendAnual.next(data);
    }
    updategestRiesgo(data: any){
        this.gestRiesgo.next(data);
    }
    updategestidcarteras (data: any){
        this.gestidcarteras.next(data);
    }
    updategestFechaFiltro(data: any){
        this.gestFechaFiltro.next(data);
    }
    updategestOptimaWallet(data: any){
        this.gestOptimaWallet.next(data);
    }

}